import {Transformer} from '../Transformer';

class JsonTransformer extends Transformer {
    transform(response) {
        return response.json();
    }
}

export {JsonTransformer};
